"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = exports.LayoutBox = exports.layoutInterpolationFn = exports.Box = exports.boxInterpolateFn = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _space = require("@styled-system/space");

var _layout = require("@styled-system/layout");

var _flexbox = require("@styled-system/flexbox");

var _position = require("@styled-system/position");

var _border = require("@styled-system/border");

var _core = require("@styled-system/core");

var _color = require("./color");

var _baseStyle = require("../shared/baseStyle");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var boxInterpolateFn = function boxInterpolateFn(props) {
  return [_space.space, _color.color, _layout.layout, _border.border, _flexbox.flexbox, _position.position].map(function (fn) {
    return fn(props);
  });
};

exports.boxInterpolateFn = boxInterpolateFn;

var Box = _styledComponents.default.div.withConfig({
  displayName: "Box",
  componentId: "pdf9wg-0"
})(["", " ", " ", " ", ""], _baseStyle.baseStyle, function (props) {
  return props.css;
}, (0, _core.system)({
  fillColor: {
    property: 'fill',
    scale: 'colors'
  }
}), boxInterpolateFn);

exports.Box = Box;

var layoutInterpolationFn = function layoutInterpolationFn(props) {
  return [_space.space, _layout.layout, _flexbox.flexbox, _position.position].map(function (fn) {
    return fn(props);
  });
};

exports.layoutInterpolationFn = layoutInterpolationFn;

var LayoutBox = _styledComponents.default.div.withConfig({
  displayName: "Box__LayoutBox",
  componentId: "pdf9wg-1"
})(["", " ", ""], _baseStyle.baseStyle, layoutInterpolationFn);

exports.LayoutBox = LayoutBox;

var Flex = _styledComponents.default.div.withConfig({
  displayName: "Box__Flex",
  componentId: "pdf9wg-2"
})(["", " display:flex;", ""], _baseStyle.baseStyle, layoutInterpolationFn);

exports.Flex = Flex;